export default __webpack_public_path__ + "1554c124047ca06606ecf78dff6da736.png";